module.exports = __webpack_public_path__ + "img/Strandkorb.fc403ade.svg";